import React, { useEffect, useState } from 'react';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../types/firebase';
import AdminLayout from '../components/AdminLayout';
import GuestTable from '../components/GuestTable';
import Loading from '../components/Loading';
import { GuestGroup } from '../types/interfaces';

const Admin: React.FC = () => {
  const [guestGroups, setGuestGroups] = useState<GuestGroup[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchGuestGroups = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, 'guestGroups'));
        const groupsData = querySnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        })) as GuestGroup[];
        setGuestGroups(groupsData);
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchGuestGroups();
  }, []);

  return (
    <AdminLayout>
      <section className="bg-white p-6 rounded-lg shadow-md">
        {loading ? (
          <Loading size="sm" />
        ) : (
          <GuestTable guestGroups={guestGroups} />
        )}
      </section>
    </AdminLayout>
  );
};

export default Admin;
